import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

const ConversationFilter = ({ onFilterChange, onSearchChange }) => {
  const [showAll, setShowAll] = React.useState(true);

  const onShowAll = (toShow) => {
    setShowAll(toShow);
    onFilterChange(!toShow);
  }

  const renderSearchBar = () => {
    return (
      <div className="o-communication__conversation-filter-search">
        <i className="o-communication__conversation-filter-search--icon fa fa-search"></i>
        <input
          type="text"
          className="o-communication__conversation-filter-search--input"
          placeholder="Search"
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
    );
  }

  const renderControls = () => {
    return (
      <div>
        <button
          className={classNames('o-communication__button--filter o-sp-button o-sp-button--primary u-float--left u-margin-right--small o-communication__button',
            { 'o-communication__button--filter-inactive': !showAll })}
          onClick={() => onShowAll(true)}>
          All
        </button>
        <button
          className={classNames('o-communication__button--filter o-sp-button o-sp-button--update o-sp-button--primary u-float--left u-margin-right--small o-communication__button',
            { 'o-communication__button--filter-inactive': showAll })}
          onClick={() => onShowAll(false)}>
          Unread
        </button>
      </div>
    )
  }

  return (
    <div className="o-communication__conversation-filter">
      {renderSearchBar()}
      {renderControls()}
    </div>
  )
};

ConversationFilter.propTypes = {
  onFilterChange: PropTypes.func.isRequired,
  onSearchChange: PropTypes.func.isRequired,
};

const mapStateToProps = _state => ({});

export default connect(mapStateToProps, {})(ConversationFilter);
